import React from 'react'
import './FooterComponent.css'

export default function FooterComponent() {
    return (
        <div className='footer-component d-flex align-items-end justify-content-center'>
            © 2022 KAPTAIN PLYWOOD. ALL RIGHTS RESERVED
        </div>
    )
}
